(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
          (function () {
            const sourceEl = document.querySelector('script[type="application/json"][data-anwendung-source]');
            const anwendungContent = document.querySelector('[data-anwendung-content]');
            if (!sourceEl || !anwendungContent) return;

            let html;
            try {
              html = JSON.parse(sourceEl.textContent);
            } catch (e) {
              return;
            }
            if (typeof html !== 'string') return;

            sourceEl.remove();

            // Multi-line text metafields do not render newlines as HTML breaks by default.
            // Normalize CRLF, trim filler newlines around explicit <br/> (single nl only), then map
            // editor line breaks: one newline → <br>, blank lines (2+ newlines) → matching <br> count.
            html = html.replace(/\r\n/g, '\n');

            html = html.replace(/(<br\s*\/?>|<\/br>)\n(?!\n)/gi, '$1');
            html = html.replace(/([^\n])\n(<br\s*\/?>|<\/br>)/gi, '$1$2');

            html = html.replace(/\n{2,}/g, function (run) {
              return '<br>'.repeat(run.length);
            });
            html = html.replace(/\n/g, '<br>');

            const videoLabel = anwendungContent.dataset.videoLabel;

            const escapeHtml = function (s) {
              return String(s)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
            };

            const youtubePattern =
              /(\d+\s*\|\|\s*)(https?:\/\/(?:www\.)?(?:youtu\.be\/|youtube\.com\/watch\?v=)[^\s<]+)/gi;

            const youtubeLinkHtmlFor = function (youtubeUrl) {
              return (
                '<div class="we-youtube-link" style=" display: flex; align-items: center; gap: 0.75rem;">' +
                '<img src="https://cdn02.plentymarkets.com/8btls80t9ab8/frontend/SWG/icons/YouTube_100x100px.svg" alt="YouTube" width="32" height="32" style="width: 32px; height: 32px; flex-shrink: 0;">' +
                '<a href="' +
                youtubeUrl.replace(/"/g, '&quot;') +
                '" target="_blank" rel="noopener noreferrer" style="color: #000000; text-decoration: none; font-weight: 500;">' +
                escapeHtml(videoLabel) +
                '</a></div>'
              );
            };

            html = html.replace(youtubePattern, function (_full, _prefix, url) {
              return youtubeLinkHtmlFor(url.trim());
            });

            anwendungContent.innerHTML = html;
          })();
        
  } catch(e) { console.error(e); }
})();
})();
